import { useBorrowerBaseUrl } from 'core/hooks/context'

const useBorrowerUrl = (url) => {
  const baseUrl = useBorrowerBaseUrl()
  return url ? `${baseUrl}${url}` : baseUrl
}

export default useBorrowerUrl
